import { useStorageObject } from "../../app/state/storageObjectSlice/hook/use-storage-object";
import { useServiceNavigate } from "../../app/state/storageObjectSlice/hook/use-service-navigate";
import { Sidebar } from "../../common/AppSidebar";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import styles from "./styles.module.css";

export const CasesPage = () => {
  const { menuItems, selectedObject, isLoading, currentService } =
    useStorageSelectors("cases");
  const { handleSelectObject } = useStorageObject(
    "cases",
    "cases",
    currentService,
  );
  const { handleOpenModal } = useAppModals();

  useServiceNavigate("cases", "cases");

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={menuItems}
        onAdd={() =>
          handleOpenModal(
            "object_manager",
            { id: "", value: "child" },
            "create_object",
          )
        }
        onSelect={handleSelectObject}
        selectedId={selectedObject?.id ?? ""}
        service={"cases"}
        isLoading={isLoading ?? false}
      />
      {selectedObject && <SafeOutlet />}
    </div>
  );
};
